import TournamentList from "../../components/TournamentList/TournamentList.js";
import CreateTournamentButton from "../../components/CreateTournamentButton/CreateTournamentButton.js";
import { useAuth } from "../../context/AuthContext.js";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb.js";
import SEOHead from "../../components/SEO/SEOHead";
import { generateBreadcrumbStructuredData } from "../../components/SEO/StructuredData";

export default function Tournament() {
  const { user } = useAuth();

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Tournaments" },
  ];

  return (
    <>
      <SEOHead
        title="Bowling Tournaments - Find and Join Bowling Events"
        description="Discover and join bowling tournaments near you. Browse upcoming and past tournaments, view results, and register for events. Find the perfect bowling tournament for your skill level."
        keywords={[
          "bowling tournaments",
          "upcoming tournaments",
          "tournament registration",
          "bowling events",
          "tournament results",
          "bowling competition",
          "local tournaments",
          "bowling leagues",
        ]}
        canonicalUrl="/tournaments"
        structuredData={generateBreadcrumbStructuredData(breadcrumbItems)}
      />
      <div className="flex flex-col bg-brand-cream min-h-screen">
        <div className="flex justify-center mb-4">
          <Breadcrumb items={breadcrumbItems} />
        </div>
        <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 pb-12">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mt-2 mb-2 gap-2">
            <h1 className="heading-display text-3xl md:text-4xl">
              Find tournaments
            </h1>
            {user && <CreateTournamentButton />}
          </div>
          <p className="text-brand-muted mb-6">
            Upcoming tournaments and past results.
          </p>
          <TournamentList />
        </div>
      </div>
    </>
  );
}
